import {FC, useEffect} from 'react';
import {TrackReference, VideoTrack} from '@livekit/components-react';
import {TRect, useVideoPosition} from 'core';
import {Box} from '@chakra-ui/react';
import {Rnd} from 'react-rnd';

interface IProps {
  video: TrackReference;
  storageKey: string;
  fallback: TRect;
  minWidth: number;
  minHeight: number;
  zIndex: number;
  onFocus: () => void;
}

// Draggable window of one camera livestream (Ricoh Theta X)
export const LiveStreamWindow: FC<IProps> = ({
  video,
  storageKey,
  fallback,
  minWidth,
  minHeight,
  zIndex,
  onFocus
}) => {
  const position = useVideoPosition(storageKey, fallback);

  // The parent re-mounts the window on resize; reset first so it re-reads the default position
  useEffect(() => {
    window.addEventListener('resize', position.reset);
    return () => window.removeEventListener('resize', position.reset);
  }, [position]);

  if (!position.default) {
    return null;
  }

  return (
    <Rnd
      default={position.default}
      minWidth={minWidth}
      minHeight={minHeight}
      bounds={'parent'}
      style={{pointerEvents: 'auto', zIndex}}
      onDragStart={onFocus}
      onResizeStart={onFocus}
      onDragStop={position.onDragStop}
      onResizeStop={position.onResizeStop}
    >
      <Box w={'100%'} h={'100%'} bg={'black'} borderRadius={'12px'} overflow={'hidden'}>
        <VideoTrack
          trackRef={video}
          style={{width: '100%', height: '100%', objectFit: 'contain'}}
        />
      </Box>
    </Rnd>
  );
};
